import { render, staticRenderFns } from "./JobManagement.vue?vue&type=template&id=1a4023d4&scoped=true"
import script from "./JobManagement.vue?vue&type=script&lang=js"
export * from "./JobManagement.vue?vue&type=script&lang=js"
import style0 from "./JobManagement.vue?vue&type=style&index=0&id=1a4023d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4023d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a4023d4')) {
      api.createRecord('1a4023d4', component.options)
    } else {
      api.reload('1a4023d4', component.options)
    }
    module.hot.accept("./JobManagement.vue?vue&type=template&id=1a4023d4&scoped=true", function () {
      api.rerender('1a4023d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/JobManagement.vue"
export default component.exports